import { render } from "./CameraAdd.vue?vue&type=template&id=d2b31d3e"
import script from "./CameraAdd.vue?vue&type=script&lang=js"
export * from "./CameraAdd.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__